// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7039f62f","455":"fbf2f40f","977":"e3f7e0f6"}[chunkId] + ".chunk.js";
};